<template>
    <v-container fluid>
        <v-btn
            :loading="users === null"
            @click="addUser"
            bottom
            color="secondary darken-1"
            fab
            fixed
            right
            class="mb-10"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>User Profiles</h2>
                </v-subheader>
            </v-col>

            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    :loading="userSearchProgressing"
                    @click:clear="userSearchClear"
                    @input="usersSearchDebounce"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
        </v-row>
        <v-row
            justify="center"
            no-gutters
            v-if="users === null"
        >
            <v-skeleton-loader
                :key="i"
                class="ma-2 ma-sm-3 ma-md-4 ma-lg-5 ma-xl-10"
                elevation="4"
                flex
                type="card"
                v-for="i in 20"
                width="300px"
            ></v-skeleton-loader>
        </v-row>
        <v-row
            justify="center"
            no-gutters
            v-else
        >
            <v-card
                :key="user.id"
                @click="loadUserForm(user)"
                class="ma-2 ma-sm-3 ma-md-4 ma-lg-5 ma-xl-10"
                elevation="4"
                flex
                max-width="400px"
                style="overflow:hidden"
                v-for="user in users"
                v-show="!userSearchString || userFilter([user.surname,user.name])"
            >
                <v-avatar
                    height="185px"
                    max-width="100%"
                    tile
                    width="300px"
                >
                    <v-img
                        :src="user.image"
                        v-if="user.image"
                    ></v-img>
                    <v-icon
                        class="user-no-image"
                        size="185px"
                        v-else
                    >mdi-account-outline</v-icon>
                </v-avatar>

                <v-card-title>{{user.name}}</v-card-title>
                <v-card-subtitle>{{user.surname}}</v-card-subtitle>
            </v-card>
        </v-row>
        <v-dialog
            persistent
            v-model="userFormVisible"
            width="500px"
        >
            <user-form
                :key="userFormKey"
                :user-in="userFormUser"
                @close="closeUserForm"
                @deleted="deleteUser"
                @saved="updateUser"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import userForm from "../components/forms/UserForm";
import User from "../models/User.model";

export default {
    name: "Users",
    mounted: function() {
        this.$store
            .dispatch("users/getAll")
            .then(response => (this.users = response));
    },
    components: {
        userForm
        //
    },
    methods: {
        usersSearchDebounce(value) {
            if (value) {
                if (!this.userSearchProgressing)
                    this.userSearchProgressing = true;
                clearTimeout(this.userSearchTimeout);
                this.userSearchTimeout = setTimeout(
                    e => {
                        this.userSearchString = e.toLowerCase();
                        this.userSearchProgressing = false;
                    },
                    500,
                    value
                );
            } else this.userSearchString = "";
        },
        userSearchClear() {
            this.userSearchString = "";
        },
        userFilter(checkProperties) {
            return checkProperties.some(element =>
                element
                    ? element.toLowerCase().includes(this.userSearchString)
                    : false
            );
        },
        addUser() {
            var newUser = new User();
            newUser.id = 0;
            this.loadUserForm(newUser);
        },
        loadUserForm(userIn) {
            this.userFormUser = new User().set(userIn);
            this.userFormKey = userIn.id;
            this.userFormVisible = true;
        },
        closeUserForm() {
            this.userFormVisible = false;
            this.userFormUser = new User();
            this.userFormKey = null;
        },
        updateUser(updatedUser) {
            var updateIndex = this.users.findIndex(x => x.id == updatedUser.id);
            if (updateIndex > -1)
                this.$set(this.users, updateIndex, updatedUser);
            else if (updateIndex == -1) this.users.push(updatedUser);
        },
        deleteUser(deletedUser) {
            var deletedIndex = this.users.findIndex(
                x => x.id == deletedUser.id
            );
            if (deletedIndex > -1) this.$delete(this.users, deletedIndex);
        }
    },
    data: () => ({
        userFormVisible: false,
        userFormKey: 0,
        userFormUser: new User(),
        userSearchProgressing: false,
        userSearchString: "",
        userSearchTimeout: null,
        users: null
        //
    })
};
</script>

<style lang="stylus" scoped>
.user-no-image
    background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent)
</style>
